export const SearchBar = ({ onSearch }: { onSearch: (term: string) => void }) => {
  return (
    <input
      type="text"
      placeholder="Search documents..."
      onChange={(e) => onSearch(e.target.value)}
      className="p-2 m-2 border rounded w-full"
    />
  );
};